import { Outlet } from "react-router-dom";
import Container from "react-bootstrap/Container";
import Navbar from "react-bootstrap/Navbar";
import Badge from "react-bootstrap/Badge";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { LogoFull } from "../assets/icons/logoFull";

export const PublicLayout = () => {
  const { t } = useTranslation();

  return (
    <>
      <Navbar bg="white" className="border-bottom">
        <Container fluid className="px-4">
          <div className="d-flex align-items-center justify-content-between w-100">
            <div className="d-flex align-items-center">
              <Navbar.Brand href="https://onbookmarks.com" className="me-3">
                <LogoFull width="180" height="40" />
              </Navbar.Brand>
              <Badge bg="purple" className="rounded-pill px-2 py-1">
                {t("collections.public.badge")}
              </Badge>
            </div>
            <Link
              to="https://my.onbookmarks.com"
              target="_blank"
              rel="noopener noreferrer"
              className="btn btn-primary h-min-auto fw-semibold"
            >
              {t("collections.public.createOwnCollection")}
            </Link>
          </div>
        </Container>
      </Navbar>

      <main className="main-public">
        <Outlet />

        {/* Footer */}
        <footer className="mt-5 border-top bg-white">
          <Container fluid className="px-4 py-4">
            <div className="text-center small text-muted">
              <p className="mb-0">{t("collections.public.footer.copyright")}</p>
            </div>
          </Container>
        </footer>
      </main>
    </>
  );
};
